@if (announcement) {
  <announcement-bar [announcement]="announcement"></announcement-bar>
}

@if (breadCrumbInfo$(); as breadcrumbInfo) {
  @if (breadcrumbInfo.id) {
    <section [id]="breadcrumbInfo.id" [class]="'style-' + breadcrumbInfo.id">
      <app-breadcrumb-navigation
        [breadcrumbData]="breadcrumbData()"
        [selectedCategoryId]="selectedCategoryId()"
      ></app-breadcrumb-navigation>
    </section>
  }
}
@if (alphabetFilterInfo$(); as alphabetFilterInfo) {
  @if (alphabetFilterInfo.id) {
    <section [id]="alphabetFilterInfo.id" [class]="'style-' + alphabetFilterInfo.id">
      <app-a-z-filter class="selector-a-z-filter" (alphabetFilterEvent$)="alphabetFilter($event)"></app-a-z-filter>
    </section>
  }
}
@if (categoryName) {
  @if ((!pageLoading() || pageLoading() === null) && !ssrLoader) {
    <div class="home-section">
      @for (home_content_section of categoryBanners; track home_content_section) {
        @switch (home_content_section.type) {
          @case (HomeContentType.BANNER) {
            @if (home_content_section?.layout === 1 || (home_content_section?.layout !== 10 && isMobile$())) {
              @if (
                home_content_section?.type === HomeContentType.BANNER &&
                home_content_section?.state === PublishStatus.published
              ) {
                <webstore-banner-carousel
                  [banners]="home_content_section?.banner_sections || []"
                ></webstore-banner-carousel>
              }
            } @else {
              @if (home_content_section?.state === PublishStatus.published) {
                <banner-layouts [home_content_section]="home_content_section"></banner-layouts>
              }
            }
          }
        }
      }
    </div>
  }
}
@if (pageLoading() || !isBrowser) {
  <!-- Show shimmer during page loading (API calls) or SSR - fallback when previewTemplate is not ready -->
  <category-page-shimmer [layoutType]="CategoryLayoutType.LAYOUT_01"></category-page-shimmer>
} @else if (previewTemplate$() && previewTemplate$().length > 0) {
  @for (banner of previewTemplate$(); track banner; let i = $index) {
    @if (banner?.categoryLayoutConfig) {
      <!-- DEBUG: Layout Type Check -->
      <!-- Layout Type: {{ banner?.categoryLayoutConfig?.categoryLayoutType }} -->
      @switch (banner?.categoryLayoutConfig?.categoryLayoutType) {
        @case (LAYOUT_TYPE.Layout_01) {
          <app-category-page-layout-1
            [class.disabled]="pageMasking$()"
            [category]="categoryName"
            [availableFilterAttributes]="aggregations() || []"
            [currentAppliedFilters]="currentAppliedFilters()"
            [selectedMobileGridLayout]="
              banner.productCardData.advanceConfiguration.mobileGridLayout ?? MOBILE_GRID_LAYOUT.GRID_LAYOUT1
            "
            [products]="fetchedProducts().hits.hits || []"
            [pageLoading]="pageLoading()"
            [productLoading]="loading()"
            [listLoading]="listLoading()"
            [categoryLayoutData]="categoryLayoutData()"
            [sortOptions]="(sortBy$ | async) || []"
            [sortBy]="sortBy.value"
            [currentPage]="pageNumber()"
            [selectedGridViewLayout]="gridViewLayout.GRID_VIEW_LAYOUT2"
            [page]="currentPage"
            [searchValue]="searchedValue()"
            (sortByChange$)="onSortByChange($event)"
          >
          </app-category-page-layout-1>
        }
        @case (LAYOUT_TYPE.Layout_02) {
          <app-category-page-layout-2
            [class.disabled]="pageMasking$()"
            [category]="categoryName"
            [availableFilterAttributes]="aggregations() || []"
            [currentAppliedFilters]="currentAppliedFilters()"
            [selectedMobileGridLayout]="
              banner.productCardData.advanceConfiguration.mobileGridLayout ?? MOBILE_GRID_LAYOUT.GRID_LAYOUT1
            "
            [products]="fetchedProducts().hits.hits || []"
            [pageLoading]="pageLoading()"
            [productLoading]="loading()"
            [listLoading]="listLoading()"
            [categoryLayoutData]="categoryLayoutData()"
            [sortOptions]="(sortBy$ | async) || []"
            [sortBy]="sortBy.value"
            [currentPage]="pageNumber()"
            [selectedGridViewLayout]="gridViewLayout.GRID_VIEW_LAYOUT4"
            [page]="currentPage"
            [searchValue]="searchedValue()"
            (sortByChange$)="onSortByChange($event)"
          >
          </app-category-page-layout-2>
        }
        @case (LAYOUT_TYPE.Layout_03) {
          <app-category-page-layout-3
            [class.disabled]="pageMasking$()"
            [category]="categoryName"
            [availableFilterAttributes]="aggregations() || []"
            [currentAppliedFilters]="currentAppliedFilters()"
            [selectedMobileGridLayout]="
              banner.productCardData.advanceConfiguration.mobileGridLayout ?? MOBILE_GRID_LAYOUT.GRID_LAYOUT1
            "
            [products]="fetchedProducts().hits.hits || []"
            [pageLoading]="pageLoading()"
            [productLoading]="loading()"
            [listLoading]="listLoading()"
            [categoryLayoutData]="categoryLayoutData()"
            [sortOptions]="(sortBy$ | async) || []"
            [sortBy]="sortBy.value"
            [currentPage]="pageNumber()"
            [selectedGridViewLayout]="gridViewLayout.GRID_VIEW_LAYOUT2"
            [page]="currentPage"
            [searchValue]="searchedValue()"
            (sortByChange$)="onSortByChange($event)"
          >
          </app-category-page-layout-3>
        }
      }
    } @else {
      <!-- Show base-primary-viewer-panel when banner does NOT have categoryLayoutConfig -->
      <base-primary-viewer-panel [page]="currentPage" [banner]="banner"></base-primary-viewer-panel>
    }
  }
} @else if (!layoutPageConfiguration && !pageLoading()) {
  <!-- Fallback: Show default ProductsLayoutComponent only when no dynamic configuration is available -->
  <webstore-products-layout
    [breadcrumbData]="breadcrumbData()"
    [selectedCategoryId]="selectedCategoryId()"
    [sortByControl]="sortBy"
    [sortByOptionsInput]="(sortBy$ | async) || []"
    [productsInput]="fetchedProducts()"
  ></webstore-products-layout>
}
